class ProductDetailActions extends ProductDetailActionsBase {
	constructor(el) {
		super(el);
	}
}
